import React from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from "../styles/heroBanner.module.css";

export default function HeroBanner({
  title,
  subtitle,
  description,
  buttonText,
  backgroundImage,
  linkTo,
}) {
  return (
    <div id="hero" className={`d-flex align-items-center ${styles.hero}`}>
      <GatsbyImage
        image={backgroundImage}
        alt="Hero Banner"
        className={styles.heroBanner}
      />
      <div className={styles.heroBannerBefore}> </div>
      <div className="container" data-aos="zoom-out" data-aos-delay="100">
        <h1>{title}</h1>
        <h2>{subtitle}</h2>
        <p>{description}</p>
        {buttonText && (
          <div className="d-flex">
            <Link
              to={linkTo}
              className={`${styles.btn} btn scrollto`}
              id={"cta_" + title}
            >
              {buttonText}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
